import classNames from 'classnames';
import { FC, useState } from 'react';
import { MarketOrderTable } from './orders/MarketOrderTable';
import { OrderList } from '@/components/exchange/orders/OrderList';

export type MarketTab = 'orders' | 'claims';

const TABS = [
    {
        _id: 'orders',
        title: 'Orders',
        hasCount: false,
    },
    {
        _id: 'claims',
        title: 'Your Claims',
        hasCount: false,
    },
] as const;

export const MarketCard: FC = () => {
    const [activeTabId, setActiveTabId] = useState<MarketTab>('orders');
    return (
        <>
            <div className="flex justify-start w-full pb-4 mb-2 border-b-[1px] border-grey-40">
                {TABS.map((tab, i) => (
                    <button
                        id={`tab-${tab._id}`}
                        key={i}
                        aria-label={tab.title}
                        className={classNames('px-2 mb-2', {
                            'text-white': activeTabId === tab._id,
                            'text-grey-30': activeTabId !== tab._id,
                        })}
                        onClick={() => setActiveTabId(tab._id)}
                        disabled={false}
                    >
                        {tab.title}
                    </button>
                ))}
            </div>
            <div className="w-full py-4">{activeTabId === 'orders' ? <MarketOrderTable /> : <OrderList />}</div>
        </>
    );
};
